module.exports = __webpack_public_path__ + "img/Kovacs_Szecsi_Attila_2026.e8c1065c.jpg";